<h2>{{registration.description}} [{{registration.id}}]</h2>

<h3>{{courseGroup.description}} <span *ngIf="courseGroup.id != '_'">[{{courseGroup.id}}]</span></h3>

<a [routerLink]="['../']"  [queryParams]="goBack" i18n>powrót</a>

<form><div class="filters redforms">
  <div class="filter-bar">
    <label for="basic-filter" i18n>wyszukiwana fraza: </label>
    <input [(ngModel)]="search" id=basic-filter type="text" [ngModelOptions]="{standalone: true}"/>
    <input (click)="advancedFilter()" class="button" type="submit" value="wyszukaj" i18n-value />
    <label for="adv-filters-chbx">
      <span i18n>wyszukiwanie zaawansowane:</span>
    </label>
    <input #showFilters (change)="true" id='adv-filters-chbx' type="checkbox">
  </div>
  <div *ngIf="showFilters.checked" class="advanced-filters">
    <hr/>
    <ul>
      <li>
        <input #byDescription (change)="byDesrciptionShow()" id="by-description" type="checkbox"/><label for="by-description" i18n>według opisu</label>

        <ng-container *ngIf="byDescription.checked">
          <input #ii [(ngModel)]="description" [ngModelOptions]="{standalone: true}" size="100"/>
        </ng-container>
      </li>
      <li>
        <input #byDay (change)="true" id="by-day" type="checkbox"/><label for="by-day" i18n>według dnia tygodnia</label>
        <ng-container *ngIf="byDay.checked">
          <select [(ngModel)]="dayOfWeek" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let day of days" [value]="day.id">{{day.day}}</option>
          </select>
        </ng-container>
      </li>
    </ul>

  </div>
</div>
</form>

<table class="grey">
  <thead>
  <tr class="headnote">
    <td i18n>Lp.</td>
    <td i18n>Kod przedmiotu</td>
    <td class="strong" i18n>Cykl dydaktyczny</td>
    <td i18n>Nazwa przedmiotu</td>
  </tr>
  </thead>
  <tbody class="autostrong">
  <tr *ngFor="let course of courses; let i = index">
    <td>{{i + 1}}</td>
    <td>
      <a [routerLink]="[course.courseId|encode, course.term.id|encode]">{{course.courseId}}</a>
    </td>
    <td class="strong">
      {{course.term.description}}
    </td>
    <td>
      <a [routerLink]="[course.courseId|encode, course.term.id|encode]">{{course.name}}</a>
    </td>
  </tr>

  </tbody>
</table>

<a [routerLink]="['../']"  [queryParams]="goBack" i18n>powrót</a>
